import React from 'react';

const DIError = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="188"
    height="148"
    viewBox="0 0 188 148"
    fill="none"
    {...props}
  >
    <path
      d="M70.64 147.59H180.4C182.345 147.585 184.209 146.81 185.584 145.434C186.96 144.059 187.735 142.195 187.74 140.25V42.25C187.74 40.9239 187.213 39.6521 186.276 38.7145C185.338 37.7768 184.066 37.25 182.74 37.25H37.2C35.8739 37.25 34.6022 37.7768 33.6645 38.7145C32.7268 39.6521 32.2 40.9239 32.2 42.25V142.59C32.2 143.916 32.7268 145.188 33.6645 146.126C34.6022 147.063 35.8739 147.59 37.2 147.59H43.04"
      fill="#FCF6ED"
    />
    <path
      d="M40.22 69.5C57.7274 69.5 71.92 55.3074 71.92 37.8C71.92 20.2926 57.7274 6.10001 40.22 6.10001C22.7126 6.10001 8.52002 20.2926 8.52002 37.8C8.52002 55.3074 22.7126 69.5 40.22 69.5Z"
      fill="#E6525A"
    />
    <path
      d="M25.29 65.4V136.27C25.29 137.596 25.8168 138.868 26.7544 139.806C27.6921 140.743 28.9639 141.27 30.29 141.27H36.13"
      stroke="#48505C"
      strokeWidth="5.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M63.73 141.29H175.85C177.176 141.29 178.448 140.763 179.386 139.826C180.323 138.888 180.85 137.616 180.85 136.29V35.95C180.85 34.6239 180.323 33.3522 179.386 32.4145C178.448 31.4768 177.176 30.95 175.85 30.95H66.4"
      stroke="#48505C"
      strokeWidth="5.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M34.7 66.4C52.2074 66.4 66.4 52.2074 66.4 34.7C66.4 17.1926 52.2074 3 34.7 3C17.1926 3 3 17.1926 3 34.7C3 52.2074 17.1926 66.4 34.7 66.4Z"
      stroke="#48505C"
      strokeWidth="5.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M38.99 35.48L48.55 45.13C48.6969 45.252 48.8151 45.4048 48.8962 45.5777C48.9773 45.7505 49.0193 45.9391 49.0193 46.13C49.0193 46.3209 48.9773 46.5095 48.8962 46.6823C48.8151 46.8552 48.6969 47.008 48.55 47.13L46.32 49.36C46.198 49.5069 46.0452 49.625 45.8723 49.7062C45.6995 49.7873 45.5109 49.8293 45.32 49.8293C45.1291 49.8293 44.9405 49.7873 44.7677 49.7062C44.5948 49.625 44.442 49.5069 44.32 49.36L34.7 39.77L25.05 49.33C24.928 49.4769 24.7752 49.595 24.6023 49.6762C24.4295 49.7573 24.2409 49.7993 24.05 49.7993C23.8591 49.7993 23.6705 49.7573 23.4977 49.6762C23.3248 49.595 23.172 49.4769 23.05 49.33L20.85 47.1C20.7031 46.978 20.585 46.8252 20.5038 46.6523C20.4227 46.4795 20.3807 46.2909 20.3807 46.1C20.3807 45.9091 20.4227 45.7205 20.5038 45.5477C20.585 45.3748 20.7031 45.222 20.85 45.1L30.4 35.48L20.84 25.83C20.6916 25.709 20.5719 25.5565 20.4897 25.3836C20.4076 25.2106 20.3649 25.0215 20.3649 24.83C20.3649 24.6385 20.4076 24.4494 20.4897 24.2764C20.5719 24.1035 20.6916 23.951 20.84 23.83L23.07 21.59C23.1939 21.4462 23.3474 21.3308 23.52 21.2517C23.6926 21.1726 23.8802 21.1316 24.07 21.1316C24.2598 21.1316 24.4475 21.1726 24.62 21.2517C24.7926 21.3308 24.9461 21.4462 25.07 21.59L34.72 31.15L44.4 21.63C44.5239 21.4862 44.6774 21.3708 44.85 21.2917C45.0226 21.2126 45.2102 21.1716 45.4 21.1716C45.5898 21.1716 45.7775 21.2126 45.95 21.2917C46.1226 21.3708 46.2761 21.4862 46.4 21.63L48.63 23.87C48.7785 23.991 48.8981 24.1435 48.9803 24.3164C49.0624 24.4894 49.1051 24.6785 49.1051 24.87C49.1051 25.0615 49.0624 25.2506 48.9803 25.4236C48.8981 25.5965 48.7785 25.749 48.63 25.87L38.99 35.48Z"
      fill="white"
    />
    <path
      d="M79.19 58.97V82.27"
      stroke="#48505C"
      strokeWidth="5.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M123.96 58.97V82.27"
      stroke="#48505C"
      strokeWidth="5.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M73.93 117.02C81.5139 109.436 91.7998 105.176 102.525 105.176C113.25 105.176 123.536 109.436 131.12 117.02"
      stroke="#48505C"
      strokeWidth="5.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

DIError.displayName = 'DIError';

export default DIError;
